import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import Logo from '@/assets/logo.png'
import { useRouter } from 'vue-router'


export default /*@__PURE__*/_defineComponent({
  __name: 'Logo',
  setup(__props) {

const router = useRouter()

const handleClick = () => {
  router.push({
    name: 'WorkBench',
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "logo_bg c_cursor c_flex_row",
    onClick: handleClick
  }, _cache[0] || (_cache[0] = [
    _createElementVNode("span", { class: "logo_name" }, "储能云平台运营平台", -1)
  ])))
}
}

})